import { useState, useCallback } from 'react';
import api from '../components/api';

const useEnseignantData = () => {
  const [classesEnseignant, setClassesEnseignant] = useState([]);
  const [modulesEnseignant, setModulesEnseignant] = useState([]);
  const [loadingClasses, setLoadingClasses] = useState(false);
  const [loadingModules, setLoadingModules] = useState(false);

  // Récupérer les classes d'un enseignant
  const fetchClassesByEnseignant = useCallback(async (enseignantId) => {
    if (!enseignantId) {
      setClassesEnseignant([]);
      setModulesEnseignant([]); // Reset modules when enseignant changes
      return;
    }

    setLoadingClasses(true);
    setModulesEnseignant([]); // Reset modules when fetching new classes
    
    try {
      const response = await api.get(`/enseignant/get-classe-by-enseignant/${enseignantId}/`);
      setClassesEnseignant(response.data || []);
    } catch (error) {
      console.error('Erreur lors de la récupération des classes:', error);
      setClassesEnseignant([]);
    } finally {
      setLoadingClasses(false);
    }
  }, []);

  // Récupérer les modules d'un enseignant pour une classe donnée
  const fetchModulesByEnseignantClasse = useCallback(async (enseignantId, classeId) => {
    if (!enseignantId || !classeId) {
      setModulesEnseignant([]);
      return;
    }

    setLoadingModules(true);
    
    try {
      const response = await api.get(`/enseignant/get-module-by-enseignant-classe/${enseignantId}/${classeId}/`);
      setModulesEnseignant(response.data || []);
    } catch (error) {
      console.error('Erreur lors de la récupération des modules:', error);
      setModulesEnseignant([]);
    } finally {
      setLoadingModules(false);
    }
  }, []);

  // Reset des données
  const resetEnseignantData = useCallback(() => {
    setClassesEnseignant([]);
    setModulesEnseignant([]);
  }, []);

  return {
    classesEnseignant,
    modulesEnseignant,
    loadingClasses,
    loadingModules,
    fetchClassesByEnseignant,
    fetchModulesByEnseignantClasse,
    resetEnseignantData
  };
};

export default useEnseignantData; 